import React from 'react';
import './pricing.css';

const Pricing = () => {
  const pricingData = [
    {
      id: 1,
      title: 'WordPress Website',
      icon: '🌐',
      description: 'Custom WordPress website with modern design, responsive layout, and SEO optimization.',
      features: [
        'Custom Design & Development',
        'Responsive Mobile Layout',
        'SEO Optimized',
        'Security Hardening',
        '1 Month Free Support'
      ],
      price: '1,000',
      priceRange: '1,000 - 8,000',
      type: 'wordpress',
      popular: false
    },
    {
      id: 2,
      title: 'Penetration Testing',
      icon: '🛡️',
      description: 'Comprehensive security assessment to identify vulnerabilities and protect your digital assets.',
      features: [
        'Vulnerability Assessment',
        'Network Security Testing',
        'Web Application Testing',
        'Detailed Security Report',
        'Remediation Recommendations'
      ],
      price: '50',
      priceRange: '50 - 1,000',
      type: 'pentest',
      popular: true
    },
    {
      id: 3,
      title: 'Custom Package',
      icon: '🚀',
      description: 'Tailored solutions combining web development and security for your specific needs.',
      features: [
        'Custom Requirements',
        'Full-Stack Development',
        'Security Integration',
        'Ongoing Support',
        'Scalable Solutions'
      ],
      price: 'Custom',
      priceRange: 'Contact for Quote',
      type: 'custom',
      popular: false
    }
  ];

  return (
    <section className="pricing" id="pricing">
      <div className="pricing__container">
        {/* Header */}
        <div className="pricing__header">
          <span className="pricing__badge">Pricing</span>
          <h2 className="pricing__title">
            Choose Your <span className="gradient-text">Plan</span>
          </h2>
          <div className="pricing__underline"></div>
          <p className="pricing__subtitle">
            Flexible pricing options tailored to your needs
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="pricing__grid">
          {pricingData.map((item) => (
            <div 
              key={item.id} 
              className={`pricing__card ${item.popular ? 'pricing__card--popular' : ''}`}
            >
              {item.popular && (
                <div className="pricing__card-badge">
                  <span>⭐ Most Popular</span>
                </div>
              )}
              
              <div className="pricing__card-icon">
                <span className="icon-emoji">{item.icon}</span>
              </div>
              
              <h3 className="pricing__card-title">{item.title}</h3>
              <p className="pricing__card-description">{item.description}</p>

              <div className="pricing__card-price">
                <span className="price-currency">$</span>
                <span className="price-amount">{item.price}</span>
                {item.type !== 'custom' && (
                  <span className="price-period">Starting from</span>
                )}
              </div>
              
              <div className="pricing__card-range">
                <span className="range-label">Range</span>
                <span className="range-value">{item.priceRange}</span>
              </div>

              <ul className="pricing__card-features">
                {item.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <span className="feature-check">✓</span>
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>

              <a 
                href="https://t.me/itpromastery" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="pricing__card-btn"
              >
                Get Started
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12"/>
                  <polyline points="12 5 19 12 12 19"/>
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;